import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import Swal from 'sweetalert2';

const API_BASE_URL = process.env.REACT_APP_BASE_URL;

// Updated Thunk for Insert Career
export const insertCareer = createAsyncThunk(
  'careers/insertCareer',
  async (careerData, { rejectWithValue }) => {
    try {
      // Make API call to insert the career application
      const response = await axios.post(`${API_BASE_URL}/careers/insert`, careerData);

      if (response.status === 201) {
        // Success response
        Swal.fire({
          title: 'Success!',
          text: 'Career application submitted successfully.',
          icon: 'success',
          confirmButtonText: 'Okay',
        });
        return { message: 'Career application submitted successfully' };
      }

      return rejectWithValue('Error submitting career application');
    } catch (error) {
      console.error('Error in insertCareer service:', error);
      Swal.fire({
        title: 'Error!',
        text: 'There was an issue with the service.',
        icon: 'error',
        confirmButtonText: 'Try Again',
      });
      return rejectWithValue('Service-level error');
    }
  }
);
